
const IntroContentFr = () => {
    return <>
      <section className="home_banner pt-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="col_selector">
                <h2 className="poppinssemibold mb-3">
                    Le réseau social privé <br/> pour votre quartier.
                </h2>
              </div>
            </div>
          </div>
        </div>
        <img
          src="assets/images/index-banner.png"
          className="img-fluid w-100"
          alt="banner"
        />
      </section>

      <section className="known_banner">
        <div className="container">
          <div className="row">
            <div className="col-md-7"></div>
            <div
              className="col-md-5 d-flex align-items-center"
              style={{ minHeight: 660 }}
            >
              <div className="col_selector">
                <div className="known_things position-relative">
                  <img
                    src="assets/images/tick.png"
                    className="img-fluid"
                    alt="images"
                  />
                  <div>
                    <h4
                      className="mb-2 fz18 poppinssemibold"
                      style={{ color: "#F55767" }}
                    >
                        Utile
                    </h4>
                    <p className="mb-0 fz14 poppinsregular">
                        Le moyen le plus simple pour suivre tout ce qui se trouve dans votre quartier.
                    </p>
                  </div>
                </div>
                <div className="known_things position-relative">
                  <img
                    src="assets/images/lock.png"
                    className="img-fluid"
                    alt="images"
                  />
                  <div>
                    <h4
                      className="mb-2 fz18 poppinssemibold"
                      style={{ color: "#2563FF" }}
                    >
                        Privé
                    </h4>
                    <p className="mb-0 fz14 poppinsregular">
                        Un environnement privé conçu spécialement pour vous et vos voisins.
                    </p>
                  </div>
                </div>
                <div className="known_things position-relative">
                  <img
                    src="assets/images/proven.png"
                    className="img-fluid"
                    alt="images"
                  />
                  <div>
                    <h4
                      className="mb-2 fz18 poppinssemibold"
                      style={{ color: "#40975F" }}
                    >
                        Prouvé
                    </h4>
                    <p className="mb-0 fz14 poppinsregular">
                        Plus de 127 000 quartiers comptent sur Houmti
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="neighbours_section">
        <div className="container">
          <h2 className="text-center poppinssemibold base_color">
            Quand les voisins commencent à parler, de bonnes choses se produisent.
          </h2>
          <div className="row">
            <div className="col-md-4">
              <div className="col_selector">
                <img
                  src="assets/images/stronger.png"
                  className="img-fluid"
                  alt="images"
                />
                <h4
                  className="mt-4 mb-2 poppinssemibold fz18"
                  style={{ color: "#F55767" }}
                >
                  Construisez un quartier plus fort
                </h4>
                <p className="mb-0 fz14 poppinsregular">
                    Connectez-vous avec vos voisins pour rester informés et partager des informations locales utiles.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="col_selector">
                <img
                  src="assets/images/neighbour.png"
                  className="img-fluid"
                  alt="images"
                />
                <h4
                  className="mt-4 mb-2 poppinssemibold fz18"
                  style={{ color: "#2563FF" }}
                >
                  Gardez le quartier en sécurité
                </h4>
                <p className="mb-0 fz14 poppinsregular">
                    Faites attention les uns aux autres et envoyez des mises
                    à jour pour assurer la sécurité du quartier..{" "}
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="col_selector">
                <img
                  src="assets/images/sharegood.png"
                  className="img-fluid"
                  alt="images"
                />
                <h4
                  className="mt-4 mb-2 poppinssemibold fz18"
                  style={{ color: "#40975F" }}
                >
                  Partager des articles et des recommandations
                </h4>
                <p className="mb-0 fz14 poppinsregular">
                    Trouvez une bonne nourrice ou un dentiste de confiance.
                     Empruntez une échelle ou vendez la vieille bibliothèque.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
}

export default IntroContentFr;